module.exports = __webpack_public_path__ + "static/media/foto.199b898e.jpg";